import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";


const externalRouter = {
    FIND_SETTING_BY_COMPANY: "dashboard/external/setting/findByCompany/",
    SAVE: "dashboard/external/setting/save",

};


export default {
    findByCompany(companyId) {
        let newInfo = null;
        return new Promise(resolve => {
            http.get(externalRouter.FIND_SETTING_BY_COMPANY + companyId)
                .then(({data}) => {
                    const code = data.code;
                    if (code < 0) {
                        toast.error(data.message);
                        return;
                    }
                    newInfo = data.info;
                })
                .catch(ex => toast.error("Error al consultar la configuración "))
                .finally(() => resolve(newInfo));
        });
    },
    save(setting) {
        return new Promise((resolve, reject) => {
            const method = setting.id ? "put" : "post";
            let url = externalRouter.SAVE;
            http[method](url, setting)
                .then(() => {
                    toast.ok("Se guardó la configuración correctamente");
                    resolve();
                })
                .catch(error => {
                    toast.error("Error al guardar la configuración: " + error.message);
                    reject();
                });
        });
    },

};